"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractParams = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var removeUtmParametersWithPrefix = function removeUtmParametersWithPrefix() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var parsedUrl = _queryString["default"].parseUrl(url);

  var result = _objectSpread({}, parsedUrl.query);

  for (var key in params) {
    if (result.hasOwnProperty(key)) {
      delete result[key];
    }
  }

  return parsedUrl.url + "?" + _queryString["default"].stringify(result);
};

var extractUtmParam = function extractUtmParam(url, prefix) {
  var parsed = _queryString["default"].parseUrl(url);

  var utmObj = {};

  for (var key in parsed.query) {
    if (key.startsWith(prefix)) {
      utmObj[key] = parsed.query[key];
    }
  }

  return utmObj;
};

var isValidUrl = function isValidUrl(url) {
  var newUrl;

  try {
    newUrl = new URL(url);
  } catch (err) {
    return false;
  }

  return newUrl.protocol === "http:" || newUrl.protocol === "https:";
};

var extractParams = function extractParams(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? window.location.href : _ref$url,
      _ref$discard = _ref.discard,
      discard = _ref$discard === void 0 ? false : _ref$discard,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? "utm_" : _ref$prefix;

  if (isValidUrl(url)) {
    var params = extractUtmParam(url, prefix);

    if (discard) {
      history.replaceState({}, null, removeUtmParametersWithPrefix(url, params));
    }

    return params;
  }
};

exports.extractParams = extractParams;